import { clearRefinements } from 'instantsearch.js/es/widgets';
import getAttributeValue from '../../../../utils/getAttributeValue';

export const initClearRefinements = () => {
	const clearRefinementsText = getAttributeValue(
		'.applied-facets__clear',
		'data-clear-applied-facets',
	);

	return clearRefinements({
		container: '.applied-facets__clear',
		templates: {
			resetLabel({ hasRefinements }) {
				if (!hasRefinements) return;
				return clearRefinementsText;
			},
		},
	});
};
